import { APPLICATION_MODULE } from '../../pages/Application/components';
import { APPLICATION_STATUS_TYPE } from '../../utils';

export const handleViewAsApplicant =
  (applicationId: string, status: string): (() => void) =>
  () => {
    const displayApplicationProgress =
      status !== APPLICATION_STATUS_TYPE.CREATED && Boolean(status);
    const defaultActivatedWithoutParam = displayApplicationProgress
      ? APPLICATION_MODULE.APPLICATION_PROGRESS
      : APPLICATION_MODULE.PROGRAMME_CHOICES;

    window.open(
      `/application/${applicationId}?apsb=${defaultActivatedWithoutParam}`,
    );
  };
